module.exports = __webpack_public_path__ + "img/Menu-Icon.0953f01c.svg";